import { post, get, postJson  } from '../api/axios'

 const decryptBatch = {
   async decrypt( p = '',url='public/decryptBatch',type = 'post') {
    //  console.log(type);
     if (type == 'get') {
     return  await get(url, p)
    } else {
      return await postJson(url, p)
    }
   },
}

export default decryptBatch